import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { NgSelectConfig } from '@ng-select/ng-select';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { JobService } from 'src/app/services/job/job.service';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';

@Component({
  selector: 'app-add-multiple-shift',
  templateUrl: './add-multiple-shift.component.html',
  styleUrls: ['./add-multiple-shift.component.scss']
})
export class AddMultipleShiftComponent {
  public errorMessage!: string;
  // public displayedColumns: string[] = [];
  public displayedColumns: string[] = ['No.', 'job_name', 'date', 'qty', 'start_time', 'end_time', 'instant_hire', 'category', 'sub_category', 'company', 'location','experience','employee', 'dress_code', 'notes', 'action'];
  public dataSource: any;
  public shiftArr: any[] = []
  public userArr: any[] = []
  public categoryArr: any[] = []
  public locArr: any[] = [];
  public subCategoryArr: any[] = []
  public filterEmployeeArr: any[] = [];
  public dressCodeArr: any[] = [];
  public companyArr: any[] = [];
  selectedCompanyId: number = 0;
  addKey: number = 0;
  public userInfo: any;
  constructor(private dialogRef: MatDialogRef<AddMultipleShiftComponent>, private recruiterService: RecruiterService, private commonService: CommonService,
    private jobService: JobService, private selectConfig: NgSelectConfig, private appService: AppService, private datePipe: DatePipe,
  ) { }
  ngOnInit(): void {
    this.userInfo = JSON.parse(this.appService.getData('training-portal.userInfo'));
    this.selectConfig.notFoundText = 'Please fill all the above shift details to get the list';
    this.selectConfig.appendTo = 'body';
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.shiftArr = [{
      "qty": '',
      "j_n": '',
      "j_c": "",
      "j_sc": "",
      "st_dt": "",
      "ed_dt": "",
      "ins_h": 1,
      "co_i": "",
      "add": "",
      "st_ti": "",
      "ed_ti": "",
      "notes": "",
      "city": "",
      "country": "",
      "que": [],
      "rec": null,
      "prop_n": "",
      "all_day": false,
      "mi_sh": "04:00",
      "dr_c": "",
      "wages": "",
      "new_wages": "",
      "lat": '',
      "long": '',
      "emp": [],
      "date": [],
      "shift_task": [],
      "e_typ": "0", // 0 = not favourite, 1 = favourite
      "assign": 0,  // 1 = direct assign, 0 = not assign 
      "shift": "shift",
    },
      //   {
      //     "qty": 200,
      //     "j_n": "Relief Staff",
      //     "j_c": "Kitchen Staff",
      //     "j_sc": "Kitchen Porter",
      //     "date": [],
      //     "emp":[118,120],
      //     "shift_task":[{"task":"cscd"},{"task":"hiren"},{"task":"test"}],
      //     "e_typ":"0", // 0 = not favourite, 1 = favourite
      //     "assign":1,  // 1 = direct assign, 0 = not assign 
      //     "st_dt": "2024-07-23",
      //     "ed_dt": "undefined-undefined-undefined",
      //     "ins_h": "no",
      //     "shift": "shift",
      //     "add": "549,azad faliya, bank of baroda, Mota Varachha, Surat, Gujarat 394101, India",
      //     "st_ti": "",
      //     "ed_ti": "",
      //     "notes": "test",
      //     "city": "Surat",
      //     "country": "India",
      //     "mi_sh": "04:00",
      //     "dr_c": "Black Formal Shift, Black Formal Pants, Black Safety Shoes ( No logos or stripes ) Black Socks",
      //     "wages": "19",
      //     "new_wages": "23.37",
      //     "lat": 21.2403299,
      //     "long": 72.8824819
      // }   
      // { f_n: "", l_n: "", el: '', pwd: "", c_pwd: "" },
    ]
    this.dataSource = new MatTableDataSource(this.shiftArr);
    this.getCategoryList();
    this.getAddressDetails();

    if (this.userInfo.u_typ != 0) {
      this.getCompanyList();

      if (!this.displayedColumns.includes('company')) {
        this.displayedColumns.splice(9, 0, 'company'); // Insert at the correct position
      }
    } else {
      this.displayedColumns = this.displayedColumns.filter(col => col !== 'company');
    }
}
onCancel() {
  this.dialogRef.close();
}
onDeleteItem(i: any) {
  this.shiftArr.splice(i, 1);
  this.dataSource = new MatTableDataSource(this.shiftArr);
}
onAddMore() {
  let obj = {
    "qty": '',
    "j_c": "",
    "j_sc": "",
    "st_dt": "",
    "ed_dt": "",
    "ins_h": 0,
    "co_i": "",
    "add": "",
    "st_ti": "",
    "ed_ti": "",
    "notes": "",
    "city": "",
    "country": "",
    "que": [],
    "rec": null,
    "prop_n": "",
    "all_day": false,
    "mi_sh": "04:00",
    "dr_c": "",
    "wages": "",
    "new_wages": "",
    "lat": '',
    "long": '',
    "emp": [],
    "date": [],
    "shift_task": [],
    "e_typ": "0", // 0 = not favourite, 1 = favourite
    "assign": 0,  // 1 = direct assign, 0 = not assign 
    "shift": "shift",
  };
  this.shiftArr.push(obj);
  this.dataSource = new MatTableDataSource(this.shiftArr);
}
onSave() {
  this.errorMessage = "";
  for (let i = 0; i < this.shiftArr.length; i++) {
    const user = this.shiftArr[i];
    const keysToCheck = ["qty", 'j_n', 'dr_c', 'st_dt', "j_c", "j_sc", "st_ti", "ed_ti", 'add'];

    for (let j = 0; j < keysToCheck.length; j++) {
      const key = keysToCheck[j];
      if (user[key] === '') {
        this.errorMessage = `No element in the object should be empty. Index: ${i + 1}`;
        break; // Exit the inner loop early if an empty string is found
      }
    }
    if (this.errorMessage) {
      break; // Exit the outer loop if an error message is set
    }
  }
  if (this.errorMessage == "") {
    let data = {
      "sh_typ": "2", //2= shift, 1= flexible, 0 = full job  
      "u_t": "1", // 2= recruiter employee, 1 = own employee, 0 = freelance employee 
      "repeat": "0", //1 = yes, 0 = no
      "r_txt": "",
      "r_typ": "0", //2=daily,1=weekly,0=monthly,
      "r_val": "2", //every some times 
      "r_on": [30], //[0,2,1] = weekly 
      "end_rtyp": "1", // 1=after, 0=on
      "end_r": "20",
    }
    data["j_d"] = [...this.shiftArr];
    data["j_d"] = data["j_d"].map(i => {
      delete i["sub_c"],
        i["st_dt"] = this.datePipe.transform(i["st_dt"], 'yyyy-MM-dd'),
        i["ed_dt"] = i["st_dt"];
      return i;
    });
    this.jobService.createJob(data).subscribe({
      next: (success: any) => {
        if (success["status"] == 200) {
          this.appService.showToastMessage("success", success.msg)
          this.dialogRef.close()
        }
      },
      error: (error: any) => {
        // this.spinner.hide();
        this.commonService.handleError(error);
      },
    });
  }
  return true;
}
onSelectCompany(value, i) {
  const selectedCmp = this.companyArr.find(item => item.co_i == value.value)
  this.dataSource.data[i]['locArr'] = selectedCmp.add;
  this.selectedCompanyId = selectedCmp.co_i;
  this.getEmployeeList(i);
}
getCategoryList() {
  this.recruiterService.getCategoryList({}).subscribe({
    next: (success: any) => {
      this.categoryArr = [];
      this.subCategoryArr = [];
      if (success.msg) {
        this.categoryArr = success.msg;
        this.subCategoryArr = [];
        this.subCategoryArr = this.categoryArr[0].sub_category;
      }
    },
    error: (error: any) => {
      this.commonService.handleError(error);
    },
  });
}
onSelectCategory(event, element, i) {
  let catItem = this.categoryArr.find((item) => item.j_c == event.value);
  // let catName = this.categoryArr.find((item) => item.j_c == event.value);
  // element.j_n = event.value;
  this.subCategoryArr = [];
  if (catItem) {
    this.dataSource.data[i]['sub_c'] = catItem.sub_category;
    this.subCategoryArr = catItem.sub_category;
  }
}
onSelectSubCat(element, i) {
  let j_sc = element.j_sc;
  let subCategoryItem = element.sub_c.find((item) => item.j_sc == j_sc)
  element.new_wages = subCategoryItem.wages;
  element.wages = subCategoryItem.wages;
}
onSelectLocation(element, i,typ) {
  let add = element.add;
  let fullAddress;

  if(typ == 'co'){
    fullAddress = this.locArr.find((item) => item.add == add);
    this.getEmployeeList(i)
  }else{
    fullAddress = this.dataSource.data[i].locArr.find((item) => item.add == add);
  }
  element.city = fullAddress.city;
  element.country = fullAddress.country;
  element.lat = fullAddress.lat;
  element.long = fullAddress.long;
}
getAddressDetails() {
  this.recruiterService.getDetails().subscribe({
    next: (success: Object) => {
      if (success["status"] == 200) {
        this.locArr = [];
        this.locArr = success["msg"]["company_info"]["company_add"];
        this.dressCodeArr = [];
        this.dressCodeArr = success["msg"]["uniform"];
      }
    },
    error: (error: any) => {
      // this.spinner.hide();
      this.commonService.handleError(error);
    },
  });
}
getCompanyList() {
  let data = {
    need: 2  // 1 = company list, 2 = address with company list
  }
  this.jobService.viewCompanyLocation(data).subscribe({
    next: (success: Object) => {
      if (success["status"] == 200) {
        this.companyArr = []
        this.companyArr = success["msg"]
      }
    },
    error: (error: any) => {
      this.commonService.handleError(error);
    },
  });
}
getEmployeeList(index: number) {
  let data = {
    "date": [],
    "j_c": "",
    "j_sc": "",
    "e_typ": "1", // 2 = favourite , 1 = all employee 
    "all_emp": "1",
    "co_i": this.selectedCompanyId
  };  
  this.jobService.getEmployee(data).subscribe({
    next: (success: Object) => {
      // this.myApp.successToast(success.msg);
      if (success["status"] == 200) {
        // this.appService.showToastMessage("success", success["msg"]);
        this.dataSource.data[index]['filterEmployeeArr'] = success["msg"].avl;
      }
    },
    error: (error: any) => {
      // this.spinner.hide();
      this.commonService.handleError(error);
    },
  });
}
customSearchFn(term: string, item: any) {
  term = term.toLowerCase();
  return item.first_name.toLowerCase().indexOf(term) > -1 || item.last_name.toLowerCase().indexOf(term) > -1;
}
onSubmit() {
  let data = {
    "sh_typ": "2", //2= shift, 1= flexible, 0 = full job  
    "u_t": "1", // 2= recruiter employee, 1 = own employee, 0 = freelance employee 
    "repeat": "0", //1 = yes, 0 = no
    "r_typ": "0", //2=daily,1=weekly,0=monthly,
    "r_val": "2", //every some times 
    "r_on": [30], //[0,2,1] = weekly 
    "end_rtyp": "1", // 1=after, 0=on
    "end_r": "20",
  }
  data["j_d"] = [...this.dataSource.data];

  this.jobService.createJob(data).subscribe({
    next: (success: any) => {
      if (success["status"] == 200) {
        this.appService.showToastMessage("success", success.msg);
        this.dialogRef.close();
      }
    },
    error: (error: any) => {
      // this.spinner.hide();
      this.commonService.handleError(error);
    },
  });
}


}